import { useTranslation } from 'react-i18next';
import type { SelectSellerContactsStepLabels } from '~/components/common/SelectSellerContactsStep';

export function useRandomTallySellerContactsLabels(): SelectSellerContactsStepLabels {
  const { t } = useTranslation('order-builder');
  return {
    sellerLists: {
      heading: t('order_builder.create_random_tally.seller_lists'),
      toggle: (name: string, count: number) =>
        t('order_builder.create_random_tally.seller_list_toggle', {
          name,
          count,
        }),
    },
    picker: {
      searchPlaceholder: t(
        'order_builder.create_random_tally.search_placeholder'
      ),
      searchLabel: t('order_builder.create_random_tally.search_label'),
      loading: t('order_builder.create_random_tally.loading_organizations'),
      error: t('order_builder.create_random_tally.sellers_load_failed'),
      emptyTitle: t('order_builder.create_random_tally.no_organizations_title'),
      emptyMessage: t('order_builder.create_random_tally.no_organizations'),
      noResultsTitle: t(
        'order_builder.create_random_tally.no_organization_matches_title'
      ),
      noResultsMessage: t(
        'order_builder.create_random_tally.no_organization_matches'
      ),
    },
    row: {
      contactCount: (count: number) =>
        t('order_builder.create_random_tally.contact_count', { count }),
      noContacts: t('order_builder.create_random_tally.no_contacts'),
      selectedCount: (count: number) =>
        t('order_builder.create_random_tally.selected_count', { count }),
      selectOrganization: (name: string) =>
        t('order_builder.create_random_tally.select_organization', { name }),
    },
    selectAll: t('order_builder.create_random_tally.select_all_sellers'),
  };
}
